var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7A5FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9V5C9 3.89543 9.89543 3 11 3C11.8392 3 12.5918 3.50781 12.8746 4.26074M15 10V11C15 13.2091 13.2091 15 11 15C10.0123 15 9.1134 14.6271 8.43993 14.0014M19 11C19 15.4183 15.4183 19 11 19C10.0248 19 9.08452 18.8298 8.20853 18.5152M12 19V21M3 3L21 21"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteMic);
export default __webpack_public_path__ + "static/media/mute-mic.1d8da5e5cf1fcade0162a35d2bccae27.svg";
export { ForwardRef as ReactComponent };